import React, { useMemo } from 'react';
import UploadExhibitsContent from 'components/tools/upload-exhibits';
import {
  UploadAllExhibitsPageStore,
  UploadAllExhibitsPageStoreContext,
} from 'store/pages/tools/upload-all-exhibits/pageStore';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import { RouteV2Id } from 'routes/routesConfigV2';

const UploadAllExhibitsPage: React.FC = () => {
  const pageStore = useMemo(() => new UploadAllExhibitsPageStore(), []);
  return (
    <UploadAllExhibitsPageStoreContext.Provider value={pageStore}>
      <PageInFlowNoSidebarLayout domainParams={{}} pageId={RouteV2Id.UPLOAD_ALL_EXHIBITS} pageFooter={null}>
        <UploadExhibitsContent />
      </PageInFlowNoSidebarLayout>
    </UploadAllExhibitsPageStoreContext.Provider>
  );
};

export default UploadAllExhibitsPage;
